"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z"];
//# sourceMappingURL=caret-down.js.map